var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, List, ListItem } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import config from '../Config';
import { addLanguageSlugToUrl } from '../util/PathUtil';
import { frontPageGaData } from './FrontPageBlocks';
import { injectStores } from '../util/StoresUtil';
const BLOCK_NAME = 'Arved';
let BillingBlock = class BillingBlock extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate, currentLanguage } = this.translateStore;
        return (React.createElement(List, { type: "unstyled", bordered: true },
            React.createElement(ListItem, null,
                React.createElement(Button, { url: addLanguageSlugToUrl(config.kerUrl, currentLanguage), text: translate('billingBlock.callsSmsInternet'), link: true, iconLeft: "#report", onClick: () => frontPageGaData(BLOCK_NAME, 'Kõnede, sõnumite ja interneti eristus') })),
            React.createElement(ListItem, null,
                React.createElement(Button, { url: addLanguageSlugToUrl(config.standingOrderUrl, currentLanguage), text: translate('billingBlock.standingOrderContract'), link: true, iconLeft: "#file-edit", onClick: () => frontPageGaData(BLOCK_NAME, 'E-arve püsimakseleping') })),
            React.createElement(ListItem, null,
                React.createElement(Button, { url: addLanguageSlugToUrl(config.billingAddressUrl, currentLanguage), text: translate('billingBlock.billReceiveSettings'), link: true, iconLeft: "#settings", onClick: () => frontPageGaData(BLOCK_NAME, 'Arve saamise viis') })),
            React.createElement(ListItem, null,
                React.createElement(Button, { url: addLanguageSlugToUrl(config.billsUrl, currentLanguage), text: translate('billingBlock.moreInfo'), link: true, iconLeft: "#service-other", onClick: () => frontPageGaData(BLOCK_NAME, 'Veel...') }))));
    }
};
BillingBlock = __decorate([
    injectStores,
    observer
], BillingBlock);
export default BillingBlock;
